import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import scroll from 'vue-seamless-scroll';
import { fitChartSize, numberFormat } from '@/utils';
import store from '@/store/index';
import App from './App.vue';
import router from './router';

Vue.use(scroll);
Vue.config.productionTip = false;
/* Echarts图表字体、间距自适应 */
Vue.prototype.fitChartSize = fitChartSize;
Vue.prototype.numberFormat = numberFormat;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
